import { Button } from './button.js';
export class ControlButton extends Button {
  static defaultOptions = {
    componentName: 'ControlButton',
    icon: 'search-plus',
    tooltipDirection: 'left',
    enabled: true
  };

  constructor (options) {
    super($.extend({}, ControlButton.defaultOptions, options));

    if (this.options.tooltip) {
      this.tooltip = $(
        '<span class="ca-ui-controlbutton_tooltip ca-ui-controlbutton_tooltip_dir-' +
          this.options.tooltipDirection +
          '">' +
          this.options.tooltip +
          '</span>'
      );
      this.el.append(this.tooltip);
    }
  }

  setTooltip (text) {
    if (this.tooltip) this.tooltip.text(text);
  }

  hide () {
    this.el.css('opacity', 0);
  }

  show () {
    this.el.css('opacity', 1);
  }
}
